import LogRocket from 'logrocket';
import { Environments } from './environments';
import { UserProfile } from '@/interface/profile';
import { fullName } from './util';
import { logger } from './logger';

export const logRocketUtil = {
  init: () => {
    if (!Environments.isValid(process.env.REACT_APP_ENV)) return;

    const appId = process.env.REACT_APP_LOGROCKET_APP_ID;

    if (!appId) {
      logger.warn({
        message:
          'LogRocket init skipped: REACT_APP_LOGROCKET_APP_ID is not set',
      });
      return;
    }

    LogRocket.init(appId, {
      dom: {
        inputSanitizer: 'lipsum',
      },
    });
  },

  identifyUser: (profile: UserProfile) => {
    const user = profile.value[0];
    LogRocket.identify(user.eXpMember.Uuid, {
      name: fullName(profile),
      email: user?.MemberEmail || '',
    });
  },

  identifyStaffAdmin: (adminInfo: {
    given_name?: string;
    family_name?: string;
    email?: string;
  }) => {
    const name = [adminInfo?.given_name, adminInfo?.family_name]
      .filter(Boolean)
      .join(' ');
    LogRocket.identify(adminInfo?.email || 'staff-admin', {
      name: name || 'Staff Admin',
      email: adminInfo?.email || '',
    });
  },

  trackChatResponse: (params?: {
    responseTime: number;
    messageId: string;
    messageLength: number;
    conversationId: string;
  }) => {
    const { responseTime, messageId, conversationId } = params || {};

    if (!responseTime || !messageId || !conversationId) {
      logger.warn({
        message: 'logrocket trackChatResponse: Missing params',
        context: params,
      });
      return;
    }

    LogRocket.track('Chat Response Time', params);
  },

  trackDeeplinkRedirect: (params: {
    deeplinkId: string;
    resolvedUrl?: string;
    isExternal: boolean;
  }) => {
    if (!params?.deeplinkId) {
      logger.warn({
        message: 'logRocket trackDeeplinkRedirect: Missing deeplinkId',
        context: params,
      });
      return;
    }

    LogRocket.track('Deeplink Redirect', {
      deeplinkId: params.deeplinkId,
      resolvedUrl: params.resolvedUrl || 'N/A',
      isExternal: params.isExternal,
    });
  },
};
